<template>
  <div class="WaitingForPayDetail">
    <div class="mainPart">
      <div class="rightPart">
        <div class="tip">待扣款金额</div>
        <div class="price" v-if="FinanceInfo">
          <span class="symbol">￥</span>
          <span>{{ FinanceInfo.WaitDeductAmount.toFixed(2) }}</span>
        </div>
      </div>
      <div class="btn customBtn info tapActive" @click="showPayMode = true">
        立即支付
      </div>
    </div>
    <div class="listBox">
      <div class="listTitle">待扣金额列表</div>
      <van-list
        v-model="loading"
        :finished="finished"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div class="list">
          <div class="item" v-for="(item, index) in dataList" :key="index">
            <div class="topPart">
              <div class="price">￥{{ item.OrderWaitDeductAmount }}</div>
              <div class="subItem" v-if="item.PlatformOrderID">
                <div class="label">订单号：</div>
                <div class="conetnt">{{ item.PlatformOrderID }}</div>
              </div>
              <div class="subItem" v-if="item.Remark">
                <div class="label">备注：</div>
                <div class="conetnt twoRow">
                  {{ item.Remark }}
                </div>
              </div>
            </div>
            <div class="bottomPart">
              <div class="time">
                {{ item.CreateTime | formatTime("YYYY/MM/DD HH:mm:ss") }}
              </div>
              <div
                v-if="item.EvidenceImgUrl"
                class="checkPicBtn customBtn default tapActive"
                @click="checkPicBtnEvent(item.EvidenceImgUrl)"
              >
                查看图片
              </div>
            </div>
          </div>
        </div>
        <template #finished>
          <segement-Line line-text="没有更多数据啦"> </segement-Line>
        </template>
      </van-list>
    </div>
    <preview-dialog
      v-if="previewDialogShow"
      @close="previewDialogShow = false"
      :img-src="previewImgSrc"
    >
    </preview-dialog>
    <!-- 扣除待扣金额动作画板 -->
    <van-action-sheet
      v-model="showPayMode"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      description="请选择支付方式"
      @select="selectPayMode"
    />
  </div>
</template>

<script>
import { List, ActionSheet } from "vant";
import PreviewDialog from "@/components/puppetComponent/PreviewDialog";
import SegementLine from "@/components/puppetComponent/SegementLine";
import {
  WaitDeductAmountItemGet,
  SAppAddDeductAmount,
  QueryWxPayTransactionStatus,
} from "@/api/wechatTransfer";
import baseUtil from "@/utils/base";
import { MessageBox } from "mint-ui";
export default {
  data() {
    return {
      previewImgSrc: "",
      previewDialogShow: false,
      showPayMode: false, // 是否展示扣除待扣金额动作画板
      actions: [
        { name: "余额支付", PayMethod: 0 },
        { name: "微信支付", PayMethod: 1 },
      ], // 扣除待扣金额方式数组
      loading: false,
      finished: false,
      error: false,
      page: 1,
      FinanceInfo: null, // 买家余额信息
      dataList: [],
      prepayId: "", // 支付记录
    };
  },
  components: {
    PreviewDialog,
    SegementLine,
    "van-action-sheet": ActionSheet,
    "van-list": List,
  },
  methods: {
    checkPicBtnEvent(EvidenceImgUrl) {
      this.previewImgSrc = EvidenceImgUrl;
      this.previewDialogShow = true;
    },
    // 查询支付状态接口
    queryWxPayTransactionStatus() {
      return new Promise((resolve, reject) => {
        this.$toast.loading({
          message: "支付状态同步中...",
          forbidClick: true,
        });
        QueryWxPayTransactionStatus({ prepayId: this.prepayId })
          .then((res) => {
            this.$toast.clear();
            switch (res.Data.TransactionStatus) {
              case 1:
                // 支付成功
                MessageBox({
                  title: '提示',
                  message: '待扣金额已支付成功，感谢您的理解与配合！',
                  showCancelButton: false,
                  confirmButtonText: '我知道了',
                  confirmButtonClass: 't_f23030'
                }).then((action) => {
                  if (action === "confirm") {
                    this.$router.push("balanceWithdraw")
                  }
                });
                break;
              default:
                // 其他状态
                MessageBox({
                  title: "提示",
                  message:
                    "未查询到支付成功，如已完成支付，请耐心等待1-3分钟后再次刷新，如待扣金额依然存在，请联系客服",
                  showCancelButton: true,
                  confirmButtonText: "我知道了",
                  cancelButtonText: "联系客服",
                  confirmButtonClass: "t_f23030",
                }).then((action) => {
                  if (action === "cancel") {
                    this.$router.push({
                      name: "posterDetail",
                      query: {
                        isContact: 1,
                      },
                    });
                  } else {
                    resolve();
                  }
                });
                break;
            }
          })
          .catch((err) => {
            // 其他状态
            MessageBox({
              title: "提示",
              message:
                "未查询到支付成功，如已完成支付，请耐心等待1-3分钟后再次刷新，如待扣金额依然存在，请联系客服",
              showCancelButton: true,
              confirmButtonText: "我知道了",
              cancelButtonText: "联系客服",
              confirmButtonClass: "t_f23030",
            }).then((action) => {
              if (action === "cancel") {
                this.$router.push({
                  name: "posterDetail",
                  query: {
                    isContact: 1,
                  },
                });
              } else {
                resolve();
              }
            });
          });
      });
    },
    // 选择代扣金额支付方式
    selectPayMode(item) {
      this.showPayMode = false;
      if (
        item.PayMethod === 0 &&
        Number(this.FinanceInfo.Amount) <
          Number(this.FinanceInfo.WaitDeductAmount)
      ) {
        // 选择【余额支付】时，优先判断用户余额是否大于等于待扣金额
        this.$toast("当前余额不足，请选择微信支付");
        return;
      }
      let params = {
        PayMethod: item.PayMethod,
        Amount: this.FinanceInfo.WaitDeductAmount,
      };
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      SAppAddDeductAmount(params)
        .then(async (res) => {
          if (item.PayMethod === 1) {
            this.prepayId = res.Data.package.split("=")[1];
            await baseUtil.chooseWXPay(res.Data);
            this.$toast.clear()
            await this.queryWxPayTransactionStatus();
            this.reFetchData();
          } else {
            this.$toast.clear()
            MessageBox({
              title: '提示',
              message: '待扣金额已支付成功，感谢您的理解与配合！',
              showCancelButton: false,
              confirmButtonText: '我知道了',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === "confirm") {
                this.$router.push("balanceWithdraw")
              }
            });
          }
        })
        .catch((err) => {
          this.$toast.clear()
          if (err.ErrMsg) this.$toast(err.ErrMsg);
        });
    },
    onLoad() {
      WaitDeductAmountItemGet({ page: this.page }).then((res) => {
        this.FinanceInfo = res.FinanceInfo;
        this.dataList = [...this.dataList, ...res.DataList];
        this.page++;
        this.loading = false;
        if (this.dataList.length >= res.PaginationViewModel.Total) {
          this.finished = true;
        }
      });
    },
    reFetchData() {
      this.finished = false;
      this.error = false;
      this.page = 1;
      this.dataList = [];
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.WaitingForPayDetail {
  position: relative;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  font-size: vw(14);
  .mainPart {
    display: flex;
    align-items: center;
    width: 100%;
    height: vw(80);
    background-color: #fff;
    padding: vw(10) vw(20) vw(10) vw(12);
    box-sizing: border-box;
    .rightPart {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      height: 100%;
      .price {
        font-size: vw(24);
        font-weight: 700;
        .symbol {
          font-size: vw(14);
        }
      }
    }
    .btn {
    }
  }
  .listBox {
    padding: 0 vw(12);
    margin-top: vw(20);
    .listTitle {
      font-weight: 700;
    }
    .list {
      .item {
        width: 100%;
        background-color: #fff;
        margin-top: vw(10);
        border-radius: vw(4);
        padding: 0 vw(8);
        box-sizing: border-box;
        color: #909290;
        .topPart {
          padding: vw(10) 0;
          border-bottom: 1px solid #ececec;
          box-sizing: border-box;
          .price {
            color: #f22c2c;
            font-size: vw(16);
            font-weight: 700;
          }
          .subItem {
            display: flex;
            margin-top: vw(10);
            .label {
              flex-shrink: 0;
              width: vw(60);
            }
          }
        }
        .bottomPart {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: vw(50);
          .checkPicBtn {
          }
        }
      }
    }
  }
  .customBtn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: vw(30);
    border-radius: vw(3);
    padding: 0 vw(6);
    font-size: vw(14);
    box-sizing: border-box;
    &.info {
      background-color: #4fa8ff;
      color: #fff;
    }
    &.default {
      border: 1px solid #1f1f1f;
      color: #1f1f1f;
    }
  }
}
</style>
